module.exports = __webpack_public_path__ + "static/img/logo-dark.80ba38b8.png";